import React, { useRef } from 'react';
import styled from 'styled-components';
import { compactPriceFormatter } from '../../../helpers/formatters';
import usePriceItem from '../../../hooks/usePriceItem';
import useTranslate from '../../../hooks/useTranslate';
import CurrencyIcon from '../../../shared/components/Icons/Currency';
import { getBoundingClientRect } from '../../../helpers/coordinates';

const PriceWrapper = styled.div<any>`
  position: relative;
  cursor: pointer;
  padding: 4px 6px 4px 16px;
  border: 1px solid rgba(21, 16, 53, 0.1);
  border-radius: 4px;
  background-color: #fff;
`;

const Wrapper = styled.li<any>`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
  white-space: nowrap;
  margin: 2px;
`;

const PriceColor = styled.div<{ bg: string }>`
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  background: ${(props) => props.bg};
  transition: all 0.1s linear;
  z-index: 0;
  width: 5px;
  height: 5px;
  border-radius: 3px;
`;

const StyledPrice = styled.div<{ isSelected: boolean }>`
  position: relative;
  z-index: 1;
  transition: opacity 0.1s linear;
  font-weight: ${({ isSelected }) => (isSelected ? '600' : '400')};
  font-size: 14px;
  line-height: 20px;
  color: ${({ isSelected, theme }) => (isSelected ? theme.buttonBackground : '#151035')};
  opacity: ${({ isSelected }) => (isSelected ? 1 : '0.4')};

  svg,
  img {
    margin: 0 4px;
  }
`;

const PriceItem = ({ price, mouseEnterHandler, mouseLeaveHandler }) => {
  const { isSelected, togglePrice } = usePriceItem({ price });
  const { t } = useTranslate();
  const priceItemRef = useRef<HTMLLIElement>();

  const onMouseEnter = () => {
    if (priceItemRef.current) {
      const { left } = getBoundingClientRect(priceItemRef.current);

      mouseEnterHandler({
        content: price.tooltip,
        left,
      });
    }
  };

  return (
    <Wrapper
      onClick={togglePrice}
      onMouseEnter={onMouseEnter}
      onMouseLeave={mouseLeaveHandler}
      ref={priceItemRef}
    >
      <PriceWrapper>
        <PriceColor bg={price.color} />
        <StyledPrice isSelected={isSelected}>
          {`${t('from_price')} ${compactPriceFormatter(price.value)}`}
          <CurrencyIcon fill="currentColor" />
        </StyledPrice>
      </PriceWrapper>
    </Wrapper>
  );
};

export default PriceItem;
